import { ApiError } from '@discovr/common';
import { errorMessage } from './errorCopy';

/** Copy for "Copy setup from another campaign": loads another campaign's discount setup into the form as an unsaved draft. */
export const shopifyDuplicateCopy = {
  action: 'Copy setup from another campaign',
  title: 'Copy setup from another campaign',
  description:
    'Loads that campaign’s discount setup into this form. Nothing is saved until you save the form, and no codes are copied.',
  selectLabel: 'Campaign to copy from',
  selectPlaceholder: 'Choose a campaign',
  noCampaigns: 'No other campaign has a Shopify setup on this store to copy from.',
  loading: 'Loading campaigns…',
  loadFailed: 'Couldn’t load the campaigns you can copy from. Close this and try again.',
  submit: 'Copy setup',
  submitting: 'Copying…',
  notice: (name: string) => `Copied from ${name}, not saved yet`,
  discard: 'Discard',
  errors: {
    generic: 'Couldn’t copy the setup',
    notFound: 'That campaign wasn’t found, or it isn’t one of your campaigns.',
  },
} as const;

/** The reason the server refused the copy, in its own words where it gave one. */
export function duplicateFailureMessage(err: unknown): string {
  const copy = shopifyDuplicateCopy.errors;
  if (err instanceof ApiError && err.httpStatus === 404) {
    return err.message && err.message !== 'Not Found' ? err.message : copy.notFound;
  }
  return errorMessage(err, copy.generic);
}
